"use client";

import type { GetVariantIdsForTenant } from "@tilli-internal/tenant-data";
import type conEdison from "@tilli-internal/tenant-data/tenants/con-edison";
import { cva, type VariantProps } from "cva";
import { cn } from "#ui-atoms/lib/utils";
import { BaseFieldLabel, type BaseFieldLabelProps } from "./field-label";

type ConEdisonTenantVariant = GetVariantIdsForTenant<typeof conEdison>;

const conEdisonFieldLabelVariants = cva({
  base: [
    "pointer-events-none absolute z-1 text-sm font-semibold top-0 text-[1.125rem] leading-7", // enlarge by default
  ],
  variants: {
    variant: {
      default: "",
      forType: {
        // TODO: is this variant needed?
        select: "-top-5 text-[0.875rem] leading-5",
      },
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export interface ConEdisonFieldLabelProps
  extends Omit<BaseFieldLabelProps, "variant"> {
  variant?: VariantProps<typeof conEdisonFieldLabelVariants>["variant"];
  tenantVariant?: ConEdisonTenantVariant;
  autoFocus?: boolean;
}

export type InputFocusEvent = Parameters<
  Exclude<ConEdisonFieldLabelProps["onFocus"], undefined>
>[0];

export default function ConEdisonFieldLabel({
  style,
  className,
  autoFocus,
  variant,
  tenantVariant,
  ...props
}: ConEdisonFieldLabelProps) {
  return (
    <BaseFieldLabel
      {...props}
      className={cn(
        tenantVariant === "oru-reco" && [
          "data-dirty:not-data-invalid:text-oru-website-green",
          "data-invalid:text-oru-website-destructive",
        ],
        "not-data-dirty:not-data-invalid:text-lg",
        "not-data-dirty:not-data-invalid:text-inherit",
        conEdisonFieldLabelVariants({
          variant,
          className,
        }),
        className,
      )}
      style={{
        ...style,
        ...(autoFocus
          ? {
              top: "-1.25rem",
              fontSize: "0.875rem",
              lineHeight: "1.25rem",
            }
          : undefined),
      }}
    />
  );
}
